import { PaidTask } from "../types/PaidTask";
import { ProductUnion } from "../types/ProductUnion";
import { transformFromFormValues } from "./formServiceFunctions";
import { getProductData } from "./Product/ProductService/productService";

export async function persistPaidTaskFields(paidTask: PaidTask, product: ProductUnion): Promise<void> {
  const fields = Object.fromEntries(Object.entries(paidTask.formData ?? {})
    .filter(([key]) => key.startsWith("temporaryField."))
    .map(([key, value]) => [key.slice("temporaryField.".length), value]));
  const updateData = transformFromFormValues(product.productClassName, fields);
  const persist = getProductData(product.productClassName, "persist");
  await persist(updateData, product);
}
